/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import PlayersForCheckIn from './PlayersForCheckIn';
import CheckInFilters from './CheckInFilters';
import withAuth from '../../../components/hocs/withAuth';
import { debounce } from '../../../utils/debounceUtil';
import * as drawEditActions from '../../../actions/draw-edit-actions';
import CheckInSidebar from './CheckInSidebar';

const CheckInTab = (props) => {
    const { eventId, divisions, utrType, sportTypeId, showHighSchoolName } = props;
    const dispatch = useDispatch();

    const [playerFilter, setPlayerFilter] = useState(''); // filter query
    const [dateFilter, setDateFilter] = useState('all');
    const [isLoading, setIsLoading] = useState(true);
    const [playerList, setPlayerList] = useState([]);
    const [playerSelectedForCheckIn, setPlayerSelectedForCheckIn] = useState();
    const [showPanel, setShowPanel] = useState(false);
    const [dateOptions, setDateOptions] = useState([]);
    const [counts, setCounts] = useState();

    const getCheckInPlayers = async () => {
        const res = await dispatch(drawEditActions.getCheckInPlayers(eventId));
        if (res.datePicker?.length > 0) {
            setDateOptions(res.datePicker);
        }
        if (res.members?.length > 0) {
            setPlayerList(res.members);
            setCounts(res.tableCounts);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        getCheckInPlayers();
    }, []);

    const handleFilterPlayer = async (value) => {
        setIsLoading(true);
        setPlayerFilter(value);
        const res = await dispatch(drawEditActions.getCheckInPlayers(eventId, value, dateFilter));
        setPlayerList(res.members);
        setIsLoading(false);
    };

    const handleFilterDate = async (value) => {
        setIsLoading(true);
        setDateFilter(value);
        const res = await dispatch(drawEditActions.getCheckInPlayers(eventId, playerFilter, value));
        setPlayerList(res.members);
        setCounts(res.tableCounts);
        setIsLoading(false);
    };

    const debouncedHandleFilterPlayer = debounce(handleFilterPlayer, 250);

    const handleClosePanel = () => {
        setShowPanel(false);
    };
    const handleSelectPlayerForCheckIn = async (player) => {
        const playerData = await dispatch(drawEditActions.getPlayerInfoForCheckIn(eventId, player.memberId));
        setPlayerSelectedForCheckIn(playerData);
        setShowPanel(true);
    };

    const handleSortByName = async (sortType) => {
        setIsLoading(true);
        const res = await dispatch(drawEditActions.getCheckInPlayers(eventId, playerFilter, dateFilter, sortType));
        setPlayerList(res.members);
        setIsLoading(false);
    };

    const handleSubmitCheckIn = async (memberId, drawGroups, questionsData) => {
        const checkIns = drawGroups.flatMap(group => group.draws.map(draw => ({
                drawId: draw.drawId,
                checkedIn: draw.checkedIn,
        })));
        const acknowledges = questionsData.map((question) => {
            return {
                questionId: question.id,
                isAcknowledged: question.isAcknowledged,
            };
        });
        const payload = {
            checkIns,
            acknowledges,
        };
        const res = await dispatch(drawEditActions.submitPlayerCheckIn(eventId, memberId, payload));
        if (res) {
            setShowPanel(false);
            setIsLoading(true);
            const playerData = await dispatch(drawEditActions.getPlayerInfoForCheckIn(eventId, memberId));
            setPlayerSelectedForCheckIn(playerData);
            const res = await dispatch(drawEditActions.getCheckInPlayers(eventId, playerFilter, dateFilter));
            setPlayerList(res.members);
            setCounts(res.tableCounts);
            setIsLoading(false);
        }
    };

    return (
        <>
            <CheckInFilters
                handleFilterDate={handleFilterDate}
                handleFilterPlayer={debouncedHandleFilterPlayer}
                filterPlayerValue={playerFilter}
                filterDateValue={dateFilter}
                filterDateOptions={dateOptions}
                counts={counts}
            />
            <PlayersForCheckIn
                players={playerList}
                eventId={eventId}
                utrType={utrType}
                divisions={divisions}
                sportTypeId={sportTypeId}
                showHighSchoolName={showHighSchoolName}
                isLoading={isLoading}
                handleSelectPlayerForCheckIn={handleSelectPlayerForCheckIn}
                handleSortByName={handleSortByName}
            />
            {showPanel && playerSelectedForCheckIn && (
                <CheckInSidebar
                    handleClosePanel={handleClosePanel}
                    handleSubmitCheckIn={handleSubmitCheckIn}
                    playerSelectedForCheckIn={playerSelectedForCheckIn}
                />
            )}
        </>
    );
};

CheckInTab.propTypes = {
    eventId: PropTypes.string,
    divisions: PropTypes.arrayOf(any).isRequired,
    utrType: PropTypes.string.isRequired,
    sportTypeId: PropTypes.string.isRequired,
    showHighSchoolName: PropTypes.bool,
};

CheckInTab.defaultProps = {
    eventId: '',
    showHighSchoolName: false,
};

export default withAuth(CheckInTab);
